var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomSelectDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0908203 4.18191V7.45463H21.909V4.18191H15.3635V0.90918H6.63627V4.18191H0.0908203ZM8.81809 3.091V4.18191H13.1817V3.091H8.81809Z",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27264 9.63645H19.7272V27.091H2.27264V9.63645ZM5.54537 23.8183V12.9092H7.72718V23.8183H5.54537ZM9.909 12.9092V23.8183H12.0908V12.9092H9.909ZM14.2726 23.8183V12.9092H16.4545V23.8183H14.2726Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomSelectDelete);
export default __webpack_public_path__ + "static/media/CustomSelectDelete.47ccbcfb11eb6d55edcf07ce2438101c.svg";
export { ForwardRef as ReactComponent };